import React, { useMemo } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import styled from 'styled-components';
import { Icon } from 'nallian-shared-ui/lib/components';
import { formatDate, formatDateTime } from 'nallian-shared-ui/lib/lib/dateTime';
import { hhmmssToMinutes } from '../helpers/hhmmssToMinutes';

const getText = (options, value, t) => {
  const option = options.find(o => o.value === value);
  if (option?.translationKey) return t(option.translationKey);

  return option?.text;
};

const ReadOnlyFieldValueComponent = styled(
  ({ input, className, options, isDate, isDateTime, isBool, emptyValue, isDuration, t }) => {
    const text = useMemo(() => {
      if (isDuration) {
        return input.value ? t('xMinutes', { min: hhmmssToMinutes(input.value) }) : '';
      }
      if (isDate) {
        return formatDate(input.value);
      }
      if (isDateTime) {
        return formatDateTime(input.value);
      }

      if (isBool) {
        return <Icon name={input.value ? 'check' : 'minus'} />;
      }

      return !isArray(options)
        ? input.value
        : isArray(input.value)
        ? input.value.map(v => getText(options, v, t)).join(', ')
        : getText(options, input.value, t);
    }, [isDate, isBool, isDateTime, options, input.value, t, isDuration]);

    return <div className={className}>{text || emptyValue}</div>;
  }
)`
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
  padding: calc(0.67857143em - 1px) 0.67857143em 0.67857143em 0;
  min-height: 2.67em;
`;

ReadOnlyFieldValueComponent.propTypes = {
  t: PropTypes.func.isRequired,
  input: PropTypes.object.isRequired,
  className: PropTypes.any,
  dateFormat: PropTypes.string,
  isDate: PropTypes.bool,
  isDateTime: PropTypes.bool,
  isBool: PropTypes.bool,
  emptyValue: PropTypes.string,
  isDuration: PropTypes.bool,
};

ReadOnlyFieldValueComponent.defaultProps = {
  className: undefined,
  dateFormat: undefined,
  isDate: false,
  isDateTime: false,
  isBool: false,
  emptyValue: undefined,
  isDuration: false,
};

export default withTranslation()(ReadOnlyFieldValueComponent);
